import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAdminAuthed } from '../utils/adminAuth';
import { API_BASE } from '../config/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo = useMemo(() => {
    const from = location.state?.from;
    return typeof from === 'string' && from.startsWith('/') ? from : '/admin-dashboard';
  }, [location.state]);

  const [adminId, setAdminId] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          email: adminId,
          password: password,
        }),
      });

      const data = await response.json();

      if (response.ok && data.status === 'success') {
        setAdminAuthed(true);
        navigate(redirectTo, { replace: true });
      } else {
        setError(data.message || 'Invalid Admin ID or Password');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-auth-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6', fontFamily: 'sans-serif' }}>
      <div className="admin-auth-card" style={{ backgroundColor: 'white', padding: '56px 40px 40px', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '400px', position: 'relative' }}>
        <button
          type="button"
          onClick={() => navigate('/')}
          style={{
            position: 'absolute',
            top: '16px',
            left: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            borderRadius: '8px',
            border: '1px solid #d1d5db',
            backgroundColor: 'transparent',
            color: '#374151',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5"/><polyline points="12 19 5 12 12 5"/>
          </svg>
          Back to Home
        </button>
        <h1 className="admin-auth-title" style={{ fontSize: '24px', fontWeight: 700, color: '#111827', marginBottom: '8px', textAlign: 'center' }}>Welcome back</h1>
        <p className="admin-auth-subtitle" style={{ color: '#6b7280', textAlign: 'center', marginBottom: '32px' }}>Please enter your details to login.</p>

        {error && <p style={{ color: '#ef4444', backgroundColor: '#fef2f2', padding: '12px', borderRadius: '8px', marginBottom: '24px', textAlign: 'center', fontSize: '14px' }}>{error}</p>}

        <form onSubmit={handleSubmit} className="admin-auth-form" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <label className="admin-auth-label" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <span style={{ fontSize: '14px', fontWeight: 500, color: '#374151' }}>Email</span>
            <input
              className="admin-auth-input"
              type="text"
              placeholder="Enter your email"
              style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }}
              value={adminId}
              onChange={(e) => setAdminId(e.target.value)}
              required
              autoComplete="username"
              disabled={loading}
            />
          </label>

          <label className="admin-auth-label" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <span style={{ fontSize: '14px', fontWeight: 500, color: '#374151' }}>Password</span>
            <input
              className="admin-auth-input"
              type="password"
              placeholder="Password"
              style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </label>

          <button type="submit" className="admin-auth-primary" style={{ backgroundColor: '#2563eb', color: 'white', padding: '12px', borderRadius: '8px', border: 'none', fontWeight: 600, cursor: 'pointer', marginTop: '10px' }} disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;

